module.exports = __webpack_public_path__ + "img/container.4d8c019.svg";